// Lib Imports
// TODO: remove moment and moment-range(if possible)
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Box, Grid, Button, Image } from 'grommet';
import { Draggable } from '@fullcalendar/interaction';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

// CORE imports
import FullCalendar from 'pages/components/FullCalendar';
import Spinner from 'granite/components/Spinner';
import Toast from 'granite/components/Toast';
import Divider from 'granite/components/Divider';
import EventEmitter from 'utils/event-emitter';
import DateTimePicker from 'granite/components/DateTimePicker';
import Cookies from 'universal-cookie';
import queryString from 'query-string';
import Singleton from 'utils/singleton';
import { setAuthToken } from 'utils/auth-singleton';

// Application Imports
import Filters from './components/Filters';
import ShiftAddEditModal from 'pages/components/ShiftAddEditModal';
import ShiftDeleteModal from 'pages/components/ShiftDeleteModal';
import RecurringShiftEditModal from 'pages/components/RecurringShiftEditModal';
import HeaderComponent from 'pages/components/headerComponent';
import ShiftModal from 'pages/components/ShiftModal';
import EmployeeRemoveModal from 'pages/components/EmployeeRemoveModal';
import ShiftMergeModal from 'pages/components/ShiftMergeModal';
import companyAPIGateway from 'company/gateways/company-api';
import messages from 'messages/shiftManagement';
import { mapEventToShift } from 'pages/components/FullCalendar/utils';
import './index.css';
import { fetchDepartments } from 'department/controllers/department';
import { fetchTeams } from 'team/controllers/team';
import { fetchCompanies, getBasicSettings } from 'company/controllers/company';
import { fetchEmployees, fetchEmployeesData } from 'employee/controllers/employee';
import {
  createShifts,
  fetchAllRoutes,
  fetchRouteDetails,
  updateShifts,
  deleteShifts,
  mapEmployeeToShift,
  updateEmployeeShiftMap,
} from 'shifts/controllers/shift';
import { DEPARTMENT_EVENTS, TEAM_EVENTS, COMPANY_EVENTS, EMPLOYEE_EVENTS, SHIFT_EVENTS } from './constants';

import * as UserDucks from 'accounts/ducks/user';
import withRouter from 'utils/withRouter';

const debounceFetchAllShifts = _.debounce(fetchAllRoutes, 100, {
  trailing: true,
  leading: false,
});
const defaultShiftLength = 8;
const defaultShiftModalData = { shiftId: null };
const defaultClickedDateData = { from: null, to: null };
const defaultOverlappingShiftsData = { shift: null, overlappingShifts: [] };
const defaultToastData = { visible: false, text: '', background: 'accent-1' };
const cookies = new Cookies();
let startDate = '';
let endDate = '';
let date_format = '';
let time_format_24_hr = false;
let employeeOfShift = '';
let shiftStartDate = '';
let shiftEndDate = '';

let eventEmitter = new EventEmitter();

console.log('RouteManagementPage file loaded');

function RouteManagementPage(props) {
  console.log('COMPONENT RENDER - RouteManagementPage called');
  console.log('RouteManagementPage mounted - props:', props);
  const { userProfile } = props;
  console.log('userProfile:', userProfile);
  const companyId = userProfile?.company_id || +props?.query?.company_id;
  console.log('Final companyId:', companyId);
  console.log('userProfile.company_id:', userProfile?.company_id);
  console.log('props.query.company_id:', props?.query?.company_id);
  const [shifts, setShifts] = useState([]);
  const [shiftData, setShiftData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [shiftModalData, setShiftModalData] = useState(defaultShiftModalData);
  const [clickedDateData, setClickedDateData] = useState(defaultClickedDateData);
  const [overlappingShiftsData, setOverlappingShiftsData] = useState(defaultOverlappingShiftsData);
  const [toastData, setToastData] = useState(defaultToastData);
  const externalEventsContainerRef = useRef();
  const [departments, setDepartments] = useState([]);
  const [defaultTeams, setTeams] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [layer, setLayer] = useState();
  const [selectEmployee, setselectEmployee] = useState();
  const [defaultEmployees, setEmployees] = useState([]);
  const [loader, setLoader] = useState({
    isShiftLoading: true,
  });
  const [view, setView] = useState('');
  const [RecurringShiftModalOpen, setRecurringShiftModalOpen] = useState(false);
  const [RecurringShift, setRecurringShift] = useState([]);
  const [shiftDataForRecurringShift, setShiftDataForRecurringShift] = useState([]);
  const [oldShiftData, setOldShiftData] = useState([]);
  const [revertFunc, setRevert] = useState(false);
  const [shiftDetailsEdit, setShiftDetailsEdit] = useState(false);
  const [recurringEmployeeId, setRecurringEmployeeId] = useState();
  const [recurringShiftId, setRecurringShiftId] = useState();
  const [recurringOptionId, setRecurringOptionId] = useState();
  const [recurringShiftDate, setRecurringShiftDate] = useState();
  const [disabledEventClick, setDisabledEventClick] = useState(false);
  const [isAssignButtonLoading, setAssignButtonLoading] = useState(false);
  const [submitShift, setSubmitShift] = useState({
    isSubmitting: false,
    isEditing: false,
    isDeleting: false,
    isSavingOnly: false,
    isSavingUpcoming: false,
  });
  const [initialViewDate, setInitialViewDate] = useState(new Date());
  const singleton = new Singleton();
  const { query } = props;
  useEffect(() => {
    setAuthToken(query.oAuthToken);
    fetchCompanies(eventEmitter, {
      paginate: false,
      company_id: +query.company_id,
    });
  }, [query]);

  useEffect(function init() {
    const observable = eventEmitter.getObservable();
    let subscription;
    listenObservable();

    function listenObservable() {
      subscription = observable.subscribe(event => {
        switch (event.type) {
          case DEPARTMENT_EVENTS.GET_DEPARTMENT_SUCCESS:
            setDepartments(event.data.departments);
            break;
          case DEPARTMENT_EVENTS.GET_DEPARTMENT_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, departments are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case TEAM_EVENTS.GET_TEAM_SUCCESS:
            setTeams(event.data.teams);
            break;
          case TEAM_EVENTS.GET_TEAM_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, teams are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case COMPANY_EVENTS.GET_COMPANY_SUCCESS:
            setCompanies(event.data.companies);
            break;
          case COMPANY_EVENTS.GET_COMPANY_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, companies are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case EMPLOYEE_EVENTS.GET_EMPLOYEE_SUCCESS:
            setEmployees(event.data.employees);
            break;
          case EMPLOYEE_EVENTS.GET_EMPLOYEE_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, emloyees are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case EMPLOYEE_EVENTS.GET_EMPLOYEE_DATA_SUCCESS:
            setEmployeesData(event.data);
            break;
          case EMPLOYEE_EVENTS.GET_EMPLOYEE_DATA_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, emloyees are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case SHIFT_EVENTS.GET_ALL_SHIFTS_SUCCESS:
            setShifts(event.data.routes);
            setRecurringShiftModalOpen(false);
            setSubmitShift({ isSavingOnly: false, isSavingUpcoming: false });
            setLoader({ isShiftLoading: false });
            break;
          case SHIFT_EVENTS.GET_ALL_SHIFTS_FAILURE:
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, all shifts are not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          case SHIFT_EVENTS.GET_SHIFT_DETAILS_SUCCESS:
            setClickedDateData({
              from: new Date(event?.data?.start_date),
              to: new Date(event?.data?.end_date),
              routeName: event?.data?.name,
            });
            setShiftData(event.data);
            break;
          case SHIFT_EVENTS.GET_SHIFT_DETAILS_FAILURE:
            shiftStartDate = null;
            shiftEndDate = null;
            setToastData({
              visible: true,
              text: event.data || 'something went wrong, shift data is not fetched',
              background: 'accent-2',
            });
            setTimeout(() => {
              setToastData({ visible: false, text: '', background: 'accent-1' });
            }, 3000);
            break;
          default:
        }
      });
    }
  }, []);

  const fetchData = async () => {
    console.log('query.company_id:', query.company_id);
    const effectiveCompanyId = userProfile?.company_id || +query.company_id;
    console.log('effectiveCompanyId:', effectiveCompanyId);
    if (effectiveCompanyId && singleton.company_id === null) {
      singleton.company_id = effectiveCompanyId;
      console.log('Set singleton.company_id to:', singleton.company_id);
    }
    // Validate company_id before proceeding
    if (!effectiveCompanyId || isNaN(effectiveCompanyId)) {
      console.error('Invalid company_id, cannot fetch data');
      return;
    }

    const subCompaniesData = await companyAPIGateway.fetchCompanies({
      paginate: false,
      company_id: effectiveCompanyId,
    });
    setCompanies(subCompaniesData.companies);
    getBasicSettings(eventEmitter, {
      company_id: +query.company_id,
    });
    const subCompaniesId = subCompaniesData?.companies.map(item => item.id);
    const companiesId = JSON.stringify(subCompaniesId);
    fetchDepartments(eventEmitter, {
      paginate: false,
      get_active: true,
      get_active_teams: true,
      is_active: true,
      company_id: companiesId,
    });

    fetchTeams(eventEmitter, {
      paginate: false,
      company_id: companiesId,
      is_active: true,
    });

    fetchEmployees(eventEmitter, {
      company_id: companiesId,
      is_active: true,
      paginate: false,
    });
  };

  useEffect(() => {
    if (singleton.oAuthToken === null) {
      singleton.oAuthToken = query?.oAuthToken;
    }
    fetchData();
  }, [query, singleton]);

  const onDepartmentSelect = data => {
    const deptIds = data.departments && data.departments.length ? data.departments.map(i => i.id) : [];
    const teamIds = data.selectedTeams && data.selectedTeams.length ? data.selectedTeams.map(i => i.id) : [];
    const subCompaniesId = companies.map(item => item.id);
    const companiesId = JSON.stringify(subCompaniesId);
    fetchTeams(eventEmitter, {
      paginate: false,
      company_id: companiesId,
      is_active: true,
      department_ids: JSON.stringify(deptIds),
    });

    fetchEmployees(eventEmitter, {
      company_id: companiesId,
      is_active: true,
      paginate: false,
      department_ids: JSON.stringify(deptIds),
      team_ids: JSON.stringify(teamIds),
    });
  };

  const onTeamSelect = data => {
    const teamIds = data.teams && data.teams.length ? data.teams.map(i => i.id) : [];
    const departmentIds =
      data.selectedDepartments && data.selectedDepartments.length ? data.selectedDepartments.map(item => item.id) : [];
    const subCompaniesId = companies.map(item => item.id);
    const companiesId = JSON.stringify(subCompaniesId);
    fetchEmployees(eventEmitter, {
      company_id: companiesId,
      is_active: true,
      paginate: false,
      team_ids: JSON.stringify(teamIds),
      department_ids: JSON.stringify(departmentIds),
    });
  };

  const getEmployeeShifts = (empId, boolean) => {
    let newStartDate = viewCookie.includes('Month')
      ? moment(startDate).subtract(1, 'week').format('YYYY-MM-DD')
      : moment(startDate).format('YYYY-MM-DD');
    let newEndDate = viewCookie.includes('Month')
      ? moment(endDate).add(2, 'week').format('YYYY-MM-DD')
      : moment(endDate).format('YYYY-MM-DD');

    if (boolean) {
      employeeOfShift = empId;
      fetchAllRoutes(eventEmitter, {
        paginate: false,
        employee_id: empId,
        start_date: newStartDate,
        end_date: newEndDate,
        company_id: companyId,
      });
    } else {
      employeeOfShift = '';
      fetchAllRoutes(eventEmitter, {
        paginate: false,
        start_date: newStartDate,
        end_date: newEndDate,
        company_id: companyId,
      });
    }
  };

  const eventClick = eventClick => {
    if (Boolean(eventClick.event.title) === false) return;
    const fullcalendarEvent = eventClick.event;
    shiftStartDate = fullcalendarEvent.start;
    shiftEndDate = fullcalendarEvent.end;
    if (!disabledEventClick) {
      fetchRouteDetails(eventEmitter, {
        shift_id: fullcalendarEvent.id,
      });
    }
  };

  const datesRender = useCallback(
    info => {
      const view_height = document.querySelector('.schedule-dashboard')?.offsetHeight;
      const position = cookies.get('position');
      setView(view_height);

      if (singleton.oAuthToken === null) {
        singleton.oAuthToken = query.oAuthToken;
      }

      const newStartDate = moment(info.view.currentStart).format('YYYY-MM-DD');
      const newEndDate = moment(info.view.currentEnd).format('YYYY-MM-DD');

      if (startDate !== newStartDate || endDate !== newEndDate) {
        startDate = newStartDate;
        endDate = newEndDate;

        if (shifts.length > 0) {
          setShifts([]);
        }

        if (startDate && initialViewDate !== startDate) {
          setInitialViewDate(startDate);
        }

        let fetchStartDate = info.view.type.includes('Month')
          ? moment(startDate).subtract(1, 'week').format('YYYY-MM-DD')
          : moment(startDate).format('YYYY-MM-DD');
        let fetchEndDate = info.view.type.includes('Month')
          ? moment(endDate).add(2, 'week').format('YYYY-MM-DD')
          : moment(endDate).format('YYYY-MM-DD');

        console.log('About to call debounceFetchAllShifts with companyId:', companyId);
        console.log('userProfile in datesRender:', userProfile);
        console.log('props.query in datesRender:', props.query);
        console.log('userProfile?.company_id:', userProfile?.company_id);
        console.log('props?.query?.company_id:', props?.query?.company_id);
        debounceFetchAllShifts(eventEmitter, {
          paginate: false,
          start_date: fetchStartDate,
          end_date: fetchEndDate,
          company_id: +query.company_id,
          ...(employeeOfShift ? { employee_id: employeeOfShift } : {}),
        });
      }
    },
    [shifts, initialViewDate, employeeOfShift, query.oAuthToken],
  );

  const viewCookie = cookies.get('viewType');

  return (
    <Box pad={{ left: 'medium', right: 'medium' }} margin={{ right: 'small' }} flex={{ grow: 1 }}>
      {loader.isShiftLoading && (
        <Box
          align="center"
          justify="center"
          style={{
            position: 'absolute',
            'z-index': '35',
            left: '58%',
            top: '55%',
          }}
        >
          <Spinner style={{ width: '40px', height: '40px' }} />
        </Box>
      )}
      <Box alignSelf="end" direction="row" pad={{ bottom: 'medium' }}>
        <Box
          border={{ color: 'light-4', size: 'xsmall' }}
          style={{ background: 'white', minWidth: '11.5rem' }}
          round="xsmall"
          pad="xxsmall"
          gap="large"
          margin={{ right: '0.3rem' }}
        >
          <DateTimePicker
            initialDate={initialViewDate}
            onClose={e => setInitialViewDate(e.date)}
            closeOnClick={true}
            date_format={date_format}
            shiftManagement="shiftManagement"
          />
        </Box>
        <Box gap="medium">
          {
            <Button
              alignSelf="end"
              pad="xxsmall"
              icon={
                <Image
                  src={process.env.PUBLIC_URL + '/img/dash-icon.png'}
                  alt="icon"
                  height="20"
                  className="valign-btm"
                  onClick={() => {
                    window.parent.postMessage(JSON.stringify({ message: 'SHIFT_DASHBOARD_PAGE' }), '*');
                  }}
                />
              }
              color="accent-1"
              primary
            />
          }
        </Box>
      </Box>
      {/* <Grid
        rows={['full']}
        columns={['17%', '83%']}
        gap="xsmall"
        areas={[
          { name: 'filter', start: [0, 0], end: [0, 0] },
          { name: 'content', start: [1, 0], end: [1, 0] },
        ]}
      > */}
      {
        // <Box gridArea="filter">
        //   <Filters
        //     departments={departments}
        //     defaultTeams={defaultTeams}
        //     employees={defaultEmployees}
        //     defaultShifts={shifts}
        //     setShifts={setShifts}
        //     externalEventsContainerRef={externalEventsContainerRef}
        //     eventEmitter={eventEmitter}
        //     getEmployeeShifts={getEmployeeShifts}
        //     view={view}
        //     onDepartmentSelect={onDepartmentSelect}
        //     onTeamSelect={onTeamSelect}
        //   />
        // </Box>
      }
      <Box background="light-1" pad="16px" gridArea="content" className="schedule-dashboard">
        <FullCalendar
          employees={defaultEmployees}
          shifts={shifts}
          setShifts={setShifts}
          mapEventToShift={mapEventToShift}
          fullcalendarConfig={{
            defaultView: viewCookie ? viewCookie : 'timeGridWeek',
            header: {
              left: 'prev',
              center: 'today title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek, next',
            },
            eventClick,
            eventDurationEditable: true,
            editable: true,
            droppable: true,
            eventStartEditable: true,
            plugins: ['dayGridPlugin', 'timeGridPlugin', 'interactionPlugin', 'momentPlugin'],
            selectable: true,
            navLinks: true,
            datesRender,
          }}
          selectedDate={initialViewDate}
          revertFunc={revertFunc}
          setRevert={setRevert}
          date_format={date_format}
          shiftManagement
        />
        {shiftModalData.shiftId && (
          <ShiftModal
            layer={layer}
            setLayer={setLayer}
            selectEmployee={selectEmployee}
            setselectEmployee={setselectEmployee}
            data={shiftModalData}
            setData={setShiftModalData}
            messages={messages}
            shifts={shifts}
            employees={defaultEmployees}
            shiftData={shiftData}
            employeesData={employeesData}
            date_format={date_format}
            time_format_24_hr={time_format_24_hr}
            shiftStartDate={shiftStartDate}
            shiftEndDate={shiftEndDate}
            setShiftDataForRecurringShift={setShiftDataForRecurringShift}
            setShiftData={setShiftData}
            isSubmitting={submitShift.isSubmitting}
            isEditing={submitShift.isEditing}
            setSubmitShift={setSubmitShift}
            isAssignButtonLoading={isAssignButtonLoading}
            shiftManagement
            type="routeScheduling"
            setClickedDateData={setClickedDateData}
          />
        )}
        {toastData.visible && (
          <Toast
            onClose={() => setToastData({ visible: false, text: '', background: 'accent-1' })}
            text={toastData.text}
            background={toastData.background}
          />
        )}
      </Box>
      {/* </Grid> */}
    </Box>
  );
}

const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
});

export default withRouter(connect(mapStateToProps)(RouteManagementPage));
